export default __webpack_public_path__ + "static/media/icon-border.753d716d.webp";